@if (!viewOnly) {
  <div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      @if (!summaryMode) {
        <div
          class="section-title mb-4">
          {{ 'COMMUNICATIONS.NOTIFICATION-CHANNELS' | translate }}
        </div>
      }
      @if (summaryMode) {
        <label>{{ 'COMMUNICATIONS.CHANNELS' | translate }}</label>
      }
      @if (responseRequired === true && !readonlyMode) {
        <div
          fxLayout="row"
          fxLayoutGap="8px"
          fxLayoutAlign="start center">
          <div>{{ 'COMMUNICATIONS.ADVANCED-SCHEDULER' | translate }}</div>
          <topo-switch
            [checked]="channelsCascadeSettings?.advancedMode === true"
            (checkChanged)="setAdvancedMode($event)" />
        </div>
      }
    </div>
    @if (responseRequired === true && channelsCascadeSettings?.advancedMode === true && !readonlyMode) {
      <div
        style="width: 100%"
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="start center">
        <div style="width: 250px">
          <label>{{ 'COMMUNICATIONS.CHANNEL' | translate }}</label>
        </div>
        <div style="width: 200px">
          <label>{{ 'COMMUNICATIONS.START-AFTER' | translate }}</label>
        </div>
        <div style="width: 200px">
          <label>{{ 'COMMUNICATIONS.RESEND-EVERY' | translate }}</label>
        </div>
        <div style="width: 200px">
          <label>{{ 'COMMUNICATIONS.STOP-AFTER' | translate }}</label>
        </div>
      </div>
    }
    <div>
      @for (channelNotification of channelsCascadeSettings?.channelNotifications; track channelNotification?.uId; let i = $index) {
        <div>
          @if (isValidChannel(channelNotification?.configuredChannelUId)) {
            <div
              style="width: 100%"
              fxLayout="row"
              fxLayoutAlign="start center">
              <div
                class="mb-4 channel-container"
                [ngClass]="{ 'readonly': readonlyMode && !summaryMode, 'summary': summaryMode }"
                fxLayout="row"
                fxLayoutGap="8px"
                fxLayoutAlign="space-between center">
                <div
                  fxLayout="row"
                  fxLayoutGap="{{ summaryMode ? '0px' : '8px' }}"
                  fxLayoutAlign="start center">
                  <div>
                    @if (!readonlyMode) {
                      <topo-icon-item-select
                        [selectedUId]="channelNotification?.configuredChannelUId"
                [icon]="
                  channelNotification?.configuredChannelUId ? getSelectedChannel(channelNotification?.configuredChannelUId)?.icon : null
                "
                        [label]="getSelectedChannel(channelNotification?.configuredChannelUId)?.name ?? 'COMMUNICATIONS.SELECT-CHANNEL' | translate"
                        itemLabel="name"
                        itemIcon="icon"
                        [items]="getAvailableChannelsForSelection(channelNotification?.uId, channelNotification?.configuredChannelUId) ?? []"
                        [isLarge]="true"
                        [width]="channelWidth"
                        (itemSelected)="selectedChannelChanged(channelNotification?.uId, $event)"
                      [useTopoIcons]="true"></topo-icon-item-select>
                    }
                  </div>
                  @if (responseRequired === true && channelsCascadeSettings?.advancedMode === true && !readonlyMode) {
                    <div
                      fxLayout="row"
                      fxLayoutGap="8px"
                      fxLayoutAlign="start top">
                      <div>
                        <div class="select is-secondary is-medium selection-list">
                          <select
                            [disabled]="readonlyMode"
                            [ngModel]="channelNotification?.startTimeMinutes"
                            (change)="startTimeChanged(channelNotification?.uId, $event)">
                            @for (startTime of startTimes; track startTime.value) {
                              <option
                                [value]="startTime.value">
                                {{ startTime.name }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                      <div>
                        <div class="select is-secondary is-medium selection-list">
                          <select
                            [disabled]="readonlyMode"
                            [ngModel]="channelNotification?.resendTimeMinutes"
                            (change)="resendTimeChanged(channelNotification?.uId, $event)">
                            @for (resendTime of resendTimes; track resendTime.value) {
                              <option
                                [value]="resendTime.value">
                                {{ resendTime.name }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="selection-list">
                        @if (channelNotification?.resendTimeMinutes > 0) {
                          <div
                            class="select is-secondary is-medium selection-list"
                            >
                            <select
                              [disabled]="readonlyMode"
                              [ngModel]="channelNotification?.stopTimeMinutes"
                              (change)="stopTimeChanged(channelNotification?.uId, $event)">
                              @for (stopTime of getStopTimes(channelNotification); track stopTime.value) {
                                <option
                                  [value]="stopTime.value">
                                  {{ stopTime.name }}
                                </option>
                              }
                            </select>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (readonlyMode) {
                    <div
                      class="readonly-channel-name"
                      fxLayout="row"
                      fxLayoutAlign="start center"
                      fxLayoutGap="8px">
                      <div>
                        <i
                  class="icon {{
                    channelNotification?.configuredChannelUId ? getSelectedChannel(channelNotification?.configuredChannelUId)?.icon : null
                  }}"></i>
                      </div>
                      <div>{{ getSelectedChannel(channelNotification?.configuredChannelUId)?.name }}</div>
                    </div>
                  }
                  @if (responseRequired === true && channelsCascadeSettings?.advancedMode === true && readonlyMode && !summaryMode) {
                    <div
                      class="readonly-channel-settings">
                      {{ getChannelSettingsDisplay(channelNotification) }}
                    </div>
                  }
                </div>
                @if (!readonlyMode) {
                  <div
                    class="action-delete"
                    title="{{ 'COMMUNICATIONS.REMOVE-CHANNEL' | translate }}"
                    (click)="deleteChannelClick(channelNotification?.uId)">
                    <i class="icon icon-remove_outline"></i>
                  </div>
                }
                @if (canSkip) {
                  <topo-switch
                    [checked]="getChannelActive(channelNotification?.uId)"
                    (checkChanged)="setChannelActive(channelNotification?.uId, $event)" />
                }
              </div>
            </div>
          }
          @if (
            isValidChannel(channelNotification?.configuredChannelUId) &&
            responseRequired === true &&
            channelsCascadeSettings?.advancedMode === true &&
            readonlyMode &&
            summaryMode
            ) {
            <div
              class="summary-channel-settings">
              {{ getChannelSettingsDisplay(channelNotification) }}
            </div>
          }
        </div>
      }
      <div>
        @if (!readonlyMode) {
          <button
            class="button is-secondary is-small"
            (click)="addChannel()"
            style="border-radius: 6px">
            <i class="icon icon-add_plus_zoom-in"></i>
            <span>{{ 'COMMUNICATIONS.ADD-CHANNEL-TO-GROUP' | translate }}</span>
          </button>
        }
      </div>
      <!-- Non Advanced mode common settings -->
      @if (
        responseRequired === true &&
        channelsCascadeSettings?.advancedMode !== true &&
        channelsCascadeSettings?.channelNotifications?.length > 0
        ) {
        <div
          >
          @if (!summaryMode) {
            <div
              class="section-title mt-5 mb-4">
              {{ 'COMMUNICATIONS.NOTIFICATION-SCHEDULE' | translate }}
            </div>
          }
          @if (summaryMode) {
            <label>{{ 'COMMUNICATIONS.SCHEDULE' | translate }}</label>
          }
          @if (!readonlyMode) {
            <div
              fxLayout="row"
              fxLayoutGap="8px"
              fxLayoutAlign="start top">
              <div>
                <label>{{ 'COMMUNICATIONS.START-AFTER' | translate }}</label>
                <div class="select is-secondary is-medium selection-list">
                  <select
                    [disabled]="readonlyMode"
                    [ngModel]="channelsCascadeSettings?.channelNotifications[0]?.startTimeMinutes"
                    (change)="startTimeChanged(null, $event)">
                    @for (startTime of startTimes; track startTime.value) {
                      <option
                        [value]="startTime.value">
                        {{ startTime.name }}
                      </option>
                    }
                  </select>
                </div>
              </div>
              <div>
                <label>{{ 'COMMUNICATIONS.RESEND-EVERY' | translate }}</label>
                <div class="select is-secondary is-medium selection-list">
                  <select
                    [disabled]="readonlyMode"
                    [ngModel]="channelsCascadeSettings?.channelNotifications[0]?.resendTimeMinutes"
                    (change)="resendTimeChanged(null, $event)">
                    @for (resendTime of resendTimes; track resendTime.value) {
                      <option
                        [value]="resendTime.value">
                        {{ resendTime.name }}
                      </option>
                    }
                  </select>
                </div>
              </div>
              <div>
                <label>{{ 'COMMUNICATIONS.STOP-AFTER' | translate }}</label>
                @if (channelsCascadeSettings?.channelNotifications[0]?.resendTimeMinutes > 0) {
                  <div
                    class="select is-secondary is-medium selection-list"
                    >
                    <select
                      [disabled]="readonlyMode"
                      [ngModel]="channelsCascadeSettings?.channelNotifications[0]?.stopTimeMinutes"
                      (change)="stopTimeChanged(null, $event)">
                      @for (stopTime of getStopTimes(channelsCascadeSettings?.channelNotifications[0]); track stopTime.value) {
                        <option
                          [value]="stopTime.value">
                          {{ stopTime.name }}
                        </option>
                      }
                    </select>
                  </div>
                }
              </div>
            </div>
          }
          @if (readonlyMode) {
            <div
              [ngClass]="{ 'readonly-channel-settings': !summaryMode, 'bottom-summary-channel-settings': summaryMode }"
              class="mb-2">
              {{ getChannelSettingsDisplay(channelsCascadeSettings?.channelNotifications[0]) }}
            </div>
          }
        </div>
      }
      @if (!summaryMode) {
        <div
          class="mt-1">
          {{ 'COMMUNICATIONS.NOTIFICATION-NOTICE' | translate }}
        </div>
      }
    </div>
  </div>
}
<!-- View Mode -->
@if (viewOnly) {
  <div
    [ngClass]="{ 'view-only': readonlyMode === false || hasActiveChannels() }">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div class="view-title">{{ 'COMMUNICATIONS.CHANNELS' | translate }}</div>
      @if (channelsCascadeSettings.advancedMode !== true && channelsCascadeSettings?.channelNotifications.length > 0) {
        <div class="inline-channel-settings">{{ getChannelSettingsDisplay(channelsCascadeSettings?.channelNotifications[0]) }}</div>
      }
      @if (channelsCascadeSettings.advancedMode === true && channelsCascadeSettings?.channelNotifications.length > 0) {
        <div class="inline-channel-settings">
          <a (click)="showAdvancedScheduling()">{{ 'COMMUNICATIONS.VIEW-ADVANCED-SCHEDULE' | translate }}</a>
        </div>
      }
    </div>
    <div class="view-channels-container">
      @for (channelNotification of channelsCascadeSettings?.channelNotifications; track channelNotification?.uId; let i = $index) {
        @if (isValidChannel(channelNotification?.configuredChannelUId) && (!readonlyMode || getChannelActive(channelNotification?.uId))) {
          <div
            class="channel-selector-container">
            <div
              (click)="setChannelActive(channelNotification?.uId, $event)"
              class="channel-selector"
              [ngClass]="{ 'active': getChannelActive(channelNotification?.uId) }">
              <i
            class="view-channel-icon icon {{
              channelNotification?.configuredChannelUId ? getSelectedChannel(channelNotification?.configuredChannelUId)?.icon : null
            }}"></i>
              <div class="view-channel-name">
                {{ getSelectedChannel(channelNotification?.configuredChannelUId)?.name }}
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
}

<topo-confirm
  [isActive]="showConfirmAdvanced"
  (respond)="onConfirmAdvancedClose($event)"
  title="{{ 'COMMUNICATIONS.CONFIRM-ADVANCED' | translate }}"
  htmlMessage="{{ 'COMMUNICATIONS.CONFIRM-ADVANCED-MESSAGE' | translate }}"
  noText="{{ 'COMMUNICATIONS.CONFIRM-NO' | translate }}"
  yesText="{{ 'COMMUNICATIONS.CONFIRM-YES' | translate }}"
icon="icon-alert_solid"></topo-confirm>
